import { gql } from '@apollo/client';
const TENANT_MANUFACTURER = gql `
  fragment TenantManufacturerFragment on ManufacturerNode {
    id
    status
    canBeRemoved
    canFullNameBeUpdated
    shortName
    fullName
    vatNumber
    countryOfOrigin
    addressPostalCode
    addressCity
    addressStreet
    addressNumber
    emailAddress
    contactPhone
    employeesCount
    picture
    occupiedProductionDates
    nonWorkingDays {
      id
      startDate
      endDate
    }
  }
`;
export default TENANT_MANUFACTURER;
